module.exports = __webpack_public_path__ + "img/header2.3da9c1ea.jpg";